import React from 'react'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

export function SettingsHeader({ title, children }: { title: string; children?: React.ReactNode }) {
  return (
    <SettingsHeaderStyled>
      <SettingsHeaderTitleStyled>{title}</SettingsHeaderTitleStyled>
      {children}
    </SettingsHeaderStyled>
  )
}

const SettingsHeaderStyled = styled('header')({
  backgroundColor: colors.lavender[750],
  color: colors.white,
  padding: `${spacing.smx1} ${spacing.md}`,
  height: spacing.bigx3,
})

const SettingsHeaderTitleStyled = styled('h2')({
  display: 'flex',
  alignItems: 'center',
  ...font.size.xl2,
  textTransform: 'capitalize',
})
